import { IGame, IGameProvider } from './game.interfaces';

export enum GAME_CATEGORY {
  POKER = 'poker',
  ROULETTE = 'roulette',
  SLOTS = 'slots',
  CARD = 'card',
  DICE = 'dice',
  CRASH = 'crash',
  TABLE = 'table',
  BLACKJACK = 'blackjack',
  BACCARAT = 'baccarat',
  BINGO = 'bingo',
  WHEEL_FORTUNE = 'wheel of fortune',
  TABLE_GAMES = 'Table Game',
  BOARD_GAME = 'Board Game',
  LOTTERY = 'lottery',
  FISHING = 'fishing',
  CASUAL = 'casual',
  CRAPS = 'craps',
  VIDEO_POKER = 'video poker',
  VIRTUAL_SPORTS = 'virtual sport',
  DICE_SLOT = 'dice slot',
  SINGLE_POKER = 'single poker',
  DRAGON_TIGER = 'dragon tiger',
  DRAGONTIGER = 'dragontiger',
  SIC_BO = 'sic bo',
  PROVABLY_FAIR = 'provably fair',
  KENO = 'keno',
  LIVE_DEALER = 'live dealer',
  INSTANT = 'instant',
  TEEN_PATTI = 'teen patti',
  SCRATCH_CARD = 'scratch card',
  FISH_SHOOTING = 'fish/shooting',
  CLUSTER = 'cluster',
  OTHER = 'other',
  FRUIT_GAME = 'fruit game',
  INSTANT_WIN = 'instant win',
  NCB_BACARRAT = 'NCbaccarat',
  ANDAR_BAHAR = 'andar bahar',
  ARCADE = 'arcade',
  VIDEO_BINGOS = 'videobingos',
  LOTTERY_STYLE_GAME = 'Lottery Style Game',
  MONEY_WHEEL = 'money wheel',
  INSTANT_GAME = 'instant game',
  GAME_SHOWS = 'game_shows',
  TREE_HAND_CASINO_HOLDEM = 'tree hand casino holdem',
  SHOOTING = 'shooting',
  SCRATCHCARD_MULTILEVEL = 'scratchcard multilevel',
  AMERICAN_ROULETTE = 'american roulette',
  MULTIBJ = 'MULTIBJ',
}
export interface ICategory {
  category: GAME_CATEGORY;
  label: string;
  icon: string;
  games?: IGame[];
}
export interface IProviderCategoryGames {
  provider: string;
  games?: Partial<IGame>[];
  loaded: boolean;
  open: boolean;
  num_games: number;
}
export interface ICategoryProviderGames {
  category: GAME_CATEGORY;
  label: string;
  icon: string;
  providers: IProviderCategoryGames[];
  open: boolean;
  num_games: number;
}
export interface ICatGamesOffset {
  games: IGame[] | Partial<IGame>[];
  offset: number;
  total: number;
}
